module.exports = __webpack_public_path__ + "img/hrimthrusa_small.fe0a2d0c.png";